const name = 'transportadora-dropdown-item'
export default {
  name,

  components: { }, 

  props: { 
    transportadora: {
      type: Object,
      default: {}
    }
   },

  mounted () { },

  updated () { },

  data () {
    return { }
  },

  methods: { },

  computed: { }, 

};